export default __webpack_public_path__ + "static/media/roof-main-catgry.bc84c43d.jpeg";